import React, { Suspense, useState } from "react";
import { Link } from "react-router-dom";
import {
  Badge,
  Card,
  CardBody,
  CardHeader,
  Col,
  Row,
  Container,
} from "reactstrap";
import "../../App.scss";
import usersData from "./UsersData";
// import Forms from "../Base/Forms/Forms";
import FactsTable from "../Fact_List/Tables";
import UserForm from "./UsersForm";
// import { AppHeader } from "@coreui/react";
import { useSelector, useDispatch } from "react-redux";
import useFetch from "../../Controllers/useFetch";
import { Spin } from "antd";
import { gql, useQuery, useMutation } from "@apollo/client";
import { error, success, warning } from "../../Controllers/toast";
// import DefaultHeader from "../../containers/DefaultLayout/DefaultHeader_TablePage";

const CHANGE_USER = gql`
  mutation Mutation($userId: Int!, $changeUserUserInput: RegisterInput) {
    ChangeUser(user_id: $userId, userInput: $changeUserUserInput) {
      user_id
      firstname
      lastname
      email
      mobile
      coname
      website
      country
      city
      address
      postcode
      cotel
    }
  }
`;
const GET_USER = gql`
  query GetUser($userInput: RegisterInput) {
    GetUser(userInput: $userInput) {
      email
      user_id
      firstname
      lastname
      mobile
      coname
      website
      country
      city
      address
      postcode
      cotel
    }
  }
`;

function UserRow(props) {
  const user = props.user;
  const userLink = `/users/${user.id}`;

  const getBadge = (status) => {
    return status === "Active"
      ? "success"
      : status === "Inactive"
      ? "secondary"
      : status === "Pending"
      ? "warning"
      : status === "Banned"
      ? "danger"
      : "primary";
  };

  return (
    <tr key={user.id.toString()}>
      <th scope="row">
        <Link to={userLink}>{user.id}</Link>
      </th>
      <td>
        <Link to={userLink}>{user.name}</Link>
      </td>
      <td>{user.registered}</td>
      <td>{user.role}</td>
      <td>
        <Link to={userLink}>
          <Badge color={getBadge(user.status)}>{user.status}</Badge>
        </Link>
      </td>
    </tr>
  );
}

function Users(props) {
  const { data: getUser, loading: isLoading } = useQuery(GET_USER, {
    variables:{
      userInput:{email:window.localStorage.getItem('email')}
    },
    onCompleted: (res) => {
      // console.log(res);
      setData(res.GetUser);
    },
  });
  const [changeUser] = useMutation(CHANGE_USER, {
    onCompleted: (res) => {
      // console.log(res);
      setData(res.ChangeUser);
      success("تغییرات با موفقیت ثبت شد!")
    },
    onError: (err) => {
      // console.log(err);
      error("مشکلی رخ داده است!")
    },
  });
  const lang_choiced = useSelector((state) => state.lang_change);
  const dispatch = useDispatch();
  
  const [data, setData] = useState();
  // console.log(data);
  
  const loading = () => (
    <div className="animated fadeIn pt-1 text-center">{lang_choiced.loading}...</div>
  );

  function signOut(e) {
    e.preventDefault();
    props.history.push("/login");
  }

  const userList = usersData.filter((user) => user.id < 10);
  // console.log(props.location.state, "is props link");
  // console.log(window.localStorage.getItem('email') , "is profile data");
  return (
    <div className="app animated fadeIn">
      <Container style={{ fontFamily: "B Roya" }}>
        <Suspense fallback={loading()}>
          <Row>
            <Col>
              <Card>
                <CardHeader>
                  {lang_choiced.pages.user.title}
                </CardHeader>
                <CardBody>
                  {isLoading === false && data? (
                    <UserForm
                      user={data}
                      setUser={(value) => {
                        // console.log(value, getUser.GetUser.user_id);
                        changeUser({
                          variables: {
                            userId: getUser.GetUser.user_id,
                            changeUserUserInput: value,
                          },
                        });
                      }}
                    />
                  ) : (
                    // <div>load is completed</div>
                    <div className="text-center">
                      <Spin spinning={true} tip={`${lang_choiced.loading}...`} />
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
          {
            // <Row>
            //   <Col>
            //     <FactsTable />
            //   </Col>
            // </Row>
          }
          {/* </div> */}
        </Suspense>
      </Container>
    </div>
  );
}

export default Users;
